// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Timer_wrapper__1CEoM","firstButton":"Timer_firstButton__1P6rS","secondButton":"Timer_secondButton__1ZJQg"};